export { COUNTRIES } from "./countries";
export type { Country } from "./countries";

export const DEFAULT_COUNTRY = "sn";
